import { useContext } from 'react';
import { AuthContext } from '@urbanx/agx.auth.client';

const postLogoutRedirectUri = 'https://www.autopilot.com.au/';

const useLogout = () => {
  const { logout } = useContext(AuthContext);

  return () => logout(postLogoutRedirectUri);
};

export default useLogout;
